import React, { useState, useCallback, useEffect } from 'react';
import Form, {
  Item,
  Label,
  ButtonItem,
  ButtonOptions,
  RequiredRule,
} from 'devextreme-react/form';
import LoadIndicator from 'devextreme-react/load-indicator';
import './login-form.scss';
import { observer } from 'mobx-react';
import { AuthStore } from '../../common/store';
import { useCookies } from 'react-cookie';
import moment from 'moment';
import { useHistory } from 'react-router-dom';

const idEditorOptions = {
  stylingMode: 'filled',
  placeholder: '아이디',
  mode: 'id',
};

// const emailEditorOptions = { stylingMode: 'filled', placeholder: 'Email', mode: 'email' };

const passwordEditorOptions = {
  stylingMode: 'filled',
  placeholder: '비밀번호',
  mode: 'password',
};

const rememberMeEditorOptions = {
  text: '아이디 저장',
  elementAttr: { class: 'form-text' },
};

const LoginForm = ({companyCode}) => {
  //console.log('LoginForm Load');

  const { loading, error } = AuthStore;

  const [loginInfo, setLoginInfo] = useState({
    id: '',
    password: '',
    saveId: false,
    companyCode: companyCode == '' ? '' : companyCode,
  });

  /*====== Cookie 관련 선언======*/
   const [cookies, setCookie, removeCookie] = useCookies(["rememberUserId"]); 

   const history = useHistory();

  useEffect(() => {
    if (cookies.rememberUserId !== undefined) {
      const cookieUserId = cookies.rememberUserId;
      setLoginInfo({id: cookieUserId, password: '', saveId: true, companyCode: companyCode})
    }
  }, [error]);

  const onChange = useCallback((e) => {
    const { dataField, value } = e;

    setLoginInfo((loginInfo) => ({
      ...loginInfo,
      [dataField]: value,
    }));
  }, []);

  const onSubmit = useCallback(
    (e) => {
      e.preventDefault();

      AuthStore.login(loginInfo.id, loginInfo.password, loginInfo.saveId, loginInfo.companyCode);

      // 아이디 쿠키 저장
      if (loginInfo.saveId) {
        const expires =  moment().add('1','y').toDate()
        setCookie("rememberUserId", loginInfo.id, {expires});
      } else {
        removeCookie("rememberUserId");
      }
    },
    [loginInfo]
  );

  const createAccount = useCallback(
    (e) => {
      history.push('/create-account')
    }
  )

  return (
    <form className={'login-form'} onSubmit={onSubmit}>
      <Form
        disabled={loading}
        formData={loginInfo}
        onFieldDataChanged={onChange}
      >
        <Item
          dataField={'id'}
          editorType={'dxTextBox'}
          editorOptions={idEditorOptions}
        >
          <RequiredRule message="아이디를 입력하세요" />
          <Label visible={false} />
        </Item>
        <Item
          dataField={'password'}
          editorType={'dxTextBox'}
          editorOptions={passwordEditorOptions}
        >
          <RequiredRule message="비밀번호를 입력하세요" />
          <Label visible={false} />
        </Item>
        <Item
          dataField={'saveId'}
          editorType={'dxCheckBox'}
          editorOptions={rememberMeEditorOptions}
        >
          <Label visible={false} />
        </Item>
        <ButtonItem>
          <ButtonOptions
            width={'100%'}
            height={'50px'}
            type={'default'}
            useSubmitBehavior={true}
          >
            <span className="dx-button-text" style={{ fontSize: '20px' }}>
              {loading ? (
                <LoadIndicator width={'24px'} height={'24px'} visible={true} />
              ) : (
                '로그인'
              )}
            </span>
          </ButtonOptions>
        </ButtonItem>
        {/* <ButtonItem>
          <ButtonOptions
            width={'100%'}
            type={'default'}
            onClick={createAccount}
          >
            <span className="dx-button-text">
              {loading ? (
                <LoadIndicator width={'24px'} height={'24px'} visible={true} />
              ) : (
                '계정생성'
              )}
            </span>
          </ButtonOptions>
        </ButtonItem> */}
        <Item>
            <span className="notify-error"> {error} </span>
        </Item>
      </Form>
    </form>
  );
};

export default React.memo(observer(LoginForm));
